<template>
  <div class="section py-0" style="height: 100%; overflow-y: scroll">
    <div class="section pb-0">
      <div class="columns">
        <div class="column">
          <b-button
            type="is-gold is-outlined"
            icon-left="plus"
            icon-pack="fas"
            tag="router-link"
            :to="{ name: 'NewOrg' }"
            class="mr-2"
            label="Neue Organisation"
          />

          <b-dropdown position="is-bottom-right">
            <template #trigger="{ active }">
              <b-button
                type="is-gold is-outlined"
                label="Aktionen"
                :icon-right="active ? 'angle-up' : 'angle-down'"
              />
            </template>

            <b-dropdown-item @click="downloadCSV">
              Export List to CSV
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="column is-narrow">
          <b-dropdown style="width: 150px" expanded>
            <template #trigger="{ active }">
              <b-button
                :label="truncate(productSelectLabel, 13)"
                :icon-right="active ? 'angle-up' : 'angle-down'"
                style="overflow-x: hidden; justify-content: space-between"
                expanded
              />
            </template>
            <b-dropdown-item custom>
              <b-checkbox v-model="allProductFilter"> All </b-checkbox>
            </b-dropdown-item>
            <hr class="my-0" />
            <b-dropdown-item custom>
              <b-checkbox v-model="noProduct"> No Product </b-checkbox>
            </b-dropdown-item>
            <b-dropdown-item
              v-for="product in products"
              :key="product.id"
              custom
            >
              <b-checkbox v-model="productFilters" :native-value="product.id">
                {{ product.name }}
              </b-checkbox>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="column is-narrow">
          <b-dropdown style="width: 150px" expanded>
            <template #trigger="{ active }">
              <b-button
                :label="truncate(licenseSelectLabel, 13)"
                :icon-right="active ? 'angle-up' : 'angle-down'"
                style="overflow-x: hidden; justify-content: space-between"
                expanded
              />
            </template>
            <b-dropdown-item custom>
              <b-checkbox v-model="allLicenses" @input="testFilter = ''">
                All licenses
              </b-checkbox>
            </b-dropdown-item>
            <hr class="mt-0 mb-2" />
            <b-dropdown-item
              v-for="license in licenses"
              :key="'lizenz' + license.id"
              custom
            >
              <b-checkbox
                v-model="licenseFilters"
                :native-value="license.value"
                @input="testFilter = ''"
              >
                {{ license.name }}
              </b-checkbox>
            </b-dropdown-item>
            <hr class="mt-0 mb-2" />
            <b-dropdown-item
              v-for="option in testOptions"
              :key="'test' + option.id"
              custom
            >
              <b-radio
                v-model="testFilter"
                name="testFilter"
                :native-value="option.name"
                @input="licenseFilters = []"
              >
                {{ option.name }}
              </b-radio>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon-pack="fas"
              icon="search"
            >
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="section">
      <b-table
        icon-pack="fa"
        :data="filteredOrgs"
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        :paginated="filteredOrgs.length > 20"
        :per-page="rangeRows"
        hoverable
      >
        <b-table-column
          field="name"
          label="Organisation"
          sortable
          v-slot="props"
        >
          {{ props.row.name }}
        </b-table-column>

        <b-table-column
          field="admin_users"
          label="Administrator(en)"
          v-slot="props"
        >
          <template v-for="userId in orgsUsers(props.row.id)">
            <template v-if="userById(userId).type === 'org_admin'">
              {{ userById(userId).first_name }} {{ userById(userId).last_name }}
            </template>
          </template>
          <!-- <template v-for="userId in props.row.admin_users">
              <router-link
                :key="userId"
                :to="{ name: 'ViewUser', params: { userId: userId } }"
              >
                {{ users.find((item) => item.id === userId).first_name }}
                {{ users.find((item) => item.id === userId).last_name }}
                <br />
              </router-link>
          </template> -->
        </b-table-column>

        <b-table-column field="products" label="Produkte" v-slot="props">
          <IconRow :data="orgProduct(props.row.id)" />
        </b-table-column>

        <b-table-column
          field="license_type"
          label="Lizenz"
          sortable
          v-slot="props"
        >
          <OrgTag :data="props.row.license_type" :test="props.row.test" />
        </b-table-column>

        <b-table-column
          field="expires_at"
          label="Laufzeit"
          sortable
          v-slot="props"
        >
          <span v-if="props.row.expires_at">
            {{ new Date(props.row.expires_at).toLocaleDateString("de-DE") }}
          </span>
          <span v-else> --- </span>
        </b-table-column>

        <!-- <b-table-column
          field="status"
          label="Status"
          width="40"
          sortable
          v-slot="props"
        >
          <b-icon
            v-if="props.row.status"
            type="is-success"
            icon-pack="fas"
            icon="circle"
          ></b-icon>
          <b-icon
            v-else
            type="is-danger"
            icon-pack="fas"
            icon="circle"
          ></b-icon>
        </b-table-column> -->

        <b-table-column
          field="comment"
          label="Kommentar"
          width="300"
          v-slot="props"
        >
          <b-tooltip
            v-if="isTooLong(props.row.comment, 33)"
            :label="props.row.comment"
            :position="commentTooltipPos(props.row.id)"
            size="is-large"
            type="is-gold is-light"
            multilined
          >
            {{ truncate(props.row.comment, 33) }}
          </b-tooltip>
          <span v-else>{{ props.row.comment }}</span>
        </b-table-column>

        <b-table-column field="action" label="" width="40" v-slot="props">
          <router-link
            :to="{ name: 'ViewOrg', params: { orgId: props.row.id } }"
          >
            <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
          </router-link>
        </b-table-column>

        <template #bottom-left>
          <b-select v-model="rangeRows" placeholder="Select a name">
            <option value="20">20 pro Seite</option>
            <option value="50">50 pro Seite</option>
            <option value="100">100 pro Seite</option>
            <option value="500">500 pro Seite</option>
          </b-select>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters } from "vuex";

import IconRow from "@/components/helper/IconRow.vue";
import OrgTag from "@/components/editOrg/OrgTag.vue";
import helper from "@/functions/helper";

export default {
  name: "AllOrgs",
  components: {
    IconRow,
    OrgTag
  },
  data() {
    return {
      search: "",
      checkedRows: [],
      rangeRows: 20,
      productFilters: [],
      noProduct: true,
      licenses: [
        { id: 1, name: "Main", value: "main" },
        { id: 2, name: "Sub", value: "sub" }
      ],
      licenseFilters: ["main", "sub"],
      testOptions: [
        { id: 1, name: "All Test" },
        { id: 2, name: "Main & Test" },
        { id: 3, name: "Sub & Test" }
      ],
      testFilter: ""
    };
  },
  computed: {
    ...mapGetters({
      orgs: "org/data",
      orgById: "org/dataById",
      orgLoading: "org/loading",
      orgsUsers: "org/user/dataByParentId",
      orgProduct: "org/product/dataByParentId",
      users: "user/data",
      userById: "user/dataById",
      loadingUsers: "user/loading",
      products: "product/data",
      theProduct: "product/dataById",
      productOrg: "product/org/dataByParentId"
    }),
    theOrgs() {
      // Example: if productFilters = [1, 2]
      // then orgProduct [1]    => true
      // then orgProduct [1, 3] => true
      // then orgProduct [3]    => false
      const isOrgProductInFilter = org =>
        this.orgProduct(org.id).reduce(
          (bool, productId) => bool || this.productFilters.includes(productId),
          false
        );

      // License options are multiple checkboxes and Test options are radio buttons
      // When the license checkbox is set, it will reset the test options, vice versa
      // The reset action is done at the input event of the respective checkbox/radio
      const isOrgLicenseInFilter = org => {
        if (this.testFilter === "All Test") {
          // Return all org with `test` of true (main and sub)
          return org.test === true;
        }
        if (this.testFilter === "Main & Test") {
          // Return all org with `test` of true (main only)
          return org.license_type === "main" && org.test === true;
        }
        if (this.testFilter === "Sub & Test") {
          // Return all org with `test` of true (sub only)
          return org.license_type === "sub" && org.test === true;
        }
        // Return orgs with license of `main` or `sub` (depends on the filter)
        // regardless of its `test` value
        return this.licenseFilters.includes(org.license_type);
      };

      const hasNoProduct = org => !this.orgProduct(org.id).length;

      if (this.noProduct) {
        return this.orgs.filter(
          org =>
            (hasNoProduct(org) || isOrgProductInFilter(org)) &&
            isOrgLicenseInFilter(org)
        );
      }

      return this.orgs.filter(
        org => isOrgProductInFilter(org) && isOrgLicenseInFilter(org)
      );
    },
    filteredOrgs() {
      return helper.search(this.theOrgs, ["name", "comment"], this.search);
    },
    productSelectLabel() {
      let label = "";

      if (this.productFilters.length === 0 && this.noProduct) {
        label = "No Product";
      } else if (this.productFilters.length === 0) {
        label = "Product";
      } else if (
        this.productFilters.length === this.products.length &&
        this.noProduct
      ) {
        label = "All";
      } else if (this.productFilters.length === this.products.length) {
        label = "All products";
      } else if (this.productFilters.length === 1) {
        label = this.theProduct(this.productFilters[0]).name;
      } else if (this.productFilters.length > 1) {
        label = `${this.productFilters.length} products`;
      }

      return label;
    },
    allProductFilter: {
      get() {
        return (
          this.productFilters.length === this.products.length && this.noProduct
        );
      },
      set(value) {
        if (value === true) {
          this.productFilters = [...this.products.map(product => product.id)];
          this.noProduct = true;
        } else {
          this.productFilters = [];
          this.noProduct = false;
        }
      }
    },
    licenseSelectLabel() {
      let label = "";

      if (this.testFilter) {
        label = this.testFilter;
      } else if (this.licenseFilters.length === 0) {
        label = "License";
      } else if (this.licenseFilters.length === this.licenses.length) {
        label = "All licenses";
      } else if (this.licenseFilters.length === 1) {
        label = this.capitalize(this.licenseFilters[0]);
      }

      return label;
    },
    allLicenses: {
      get() {
        return this.licenseFilters.length === this.licenses.length;
      },
      set(value) {
        this.licenseFilters = value
          ? [...this.licenses.map(license => license.value)]
          : [];
      }
    }
  },
  watch: {
    orgLoading: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === false && oldVal === true) {
          this.selectAllProductFilter();
        }
      }
    }
  },
  methods: {
    downloadCSV() {
      // const csvFormat = "data:text/csv,charset=utf-8";

      const rowHeader = [
        "ID",
        "Organisation",
        "Lizenz Typ",
        "Test Lizenz",
        "Produkte",
        "Laufzeit",
        "Kommentar"
      ].join(",");

      const csvHeader = `${rowHeader}\r\n`;

      const theProducts = orgId => {
        return this.orgProduct(orgId)
          .map(productId => this.theProduct(productId).name)
          .join(",");
      };

      const csvFinal = this.checkedRows.reduce((csv, row) => {
        csv += row.id + ","; // ID
        csv += row.name + ","; // Organisation
        csv += row.license_type + ","; // Lizenz Typ
        csv += row.test + ","; // Test Lizenz
        csv += `"[${theProducts(row.id)}]"` + ","; // Produkte
        csv += new Date(row.expires_at).toLocaleDateString("de-DE") + ","; // Laufzeit
        csv += row.comment + ","; // Kommentar
        csv += "\r\n";

        return csv;
      }, csvHeader);

      const csvFile = new Blob([csvFinal], { type: "text/csv,charset=utf-8" });
      const today = new Date().toLocaleDateString("de-DE");
      const tempLink = document.createElement("a");

      tempLink.href = window.URL.createObjectURL(csvFile);
      tempLink.download = `Standortmonitor_Nutzer_Liste_${today}.csv`;
      tempLink.click();
    },
    isTooLong(str, limit) {
      return helper.isTooLong(str, limit);
    },
    truncate(str, limit) {
      return helper.truncate(str, limit);
    },
    commentTooltipPos(id) {
      const index = this.filteredOrgs.findIndex(org => org.id === id);
      return index === 0 ? "is-bottom" : "is-top";
    },
    selectAllProductFilter() {
      this.productFilters = [...this.products.map(product => product.id)];
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  created() {
    this.selectAllProductFilter();
  }
};
</script>
